/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'portal': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M33.866 470.454V64.532H469.08v405.922H33.866zm522.151 0V64.532H991.23v405.922H556.017zm0 487.025v-405.85H991.23v405.85H556.017zm-522.15 0v-405.85h435.212v405.85H33.866z"/>'
  }
})
